export default "/_next/static/images/lead-generation-3c86d8a9b588786da90317effbd5b2ba.svg";